import { Component, ViewChild, Inject } from '@angular/core';
import { IonicPage, NavController, NavParams, Content, AlertController } from 'ionic-angular';
import * as $ from "jquery";
import { Storage } from '@ionic/storage';
import { HomePage } from '../home/home';
import { WebServices } from '../../providers/web-services/web-services';
import { DOCUMENT } from '@angular/common';
/**
 * Generated class for the ChatPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
declare var AWS:any;
@IonicPage()
@Component({
  selector: 'page-chat',
  templateUrl: 'chat.html',
})
export class ChatPage {
  @ViewChild(Content) content: Content; 
  defUser:any={firstname:"BK",email:"bishwajit.kolay@abp.in"};
  loggedInUser:any={firstname:"BK",email:"bishwajit.kolay@abp.in",uuid:""};
  lexruntime;
  lexUserId;
  sessionAttributes;
  message:any="";
  customMsg:any="";
  threadStack=[];
  msgStack=[];
  intentList={};
  rating=0;
  comment="";
  ticketcomment="";
  ratingId=0;
  arrEmoji=['&#x1F620;','&#x1F61E;','&#x1F610;','&#x1F60A;','&#x1F603;'];
  
  token:any={};
  fullUrl: any;
  allparamObj:any={};
  usertoken:any;
  showSearchBotPanel=false;
  showChatBotPanel=false;
  
  constructor(@Inject(DOCUMENT) private document: any, public navCtrl: NavController, public navParams: NavParams, public alertCtrl: AlertController,private webServices: WebServices,private storage: Storage) {
	  //this.loggedInUser=this.navParams.get("user");
	  this.fullUrl = this.document.location.href;
	  //console.log("this.fullUrl", this.fullUrl);
	  if(this.fullUrl.split('?')[1]){
	  this.allparamObj = this.fullUrl.split('?')[1].split("&").reduce(function(obj, str, index) {
		// console.log("this.allparamObjttt", str);
		var i = str.indexOf('=');
		let strParts = str.split("=");
		if (strParts[0] && strParts[1]) { //<-- Make sure the key & value are not undefined
			
		  obj[strParts.shift()] = strParts.join('=').trim(); //<-- Get rid of extra spaces at beginning of value strings
		}
		return obj;
	  }, {});
	}

	////set token if get in url /////
	this.usertoken = this.allparamObj.token;
	console.log("this.usertoken", this.usertoken);
  }
  

  initialize(){
	this.intentList={};
	this.lexUserId = this.defUser.email;
	//this.showResponseText("Hey "+this.loggedInUser.firstname+"! Welcome to Mita – My IT Assistant.");
	this.showResponseText("Welcome to Aaro Ananda Support.");
	if(this.customMsg){
		this.showResponseText(this.customMsg);
	}
	this.submitChat("hi",0,false);
  }
  
  gotoHomePage(){
	  this.navCtrl.setRoot(HomePage);
	  //document.location.href="https://mita.abp.in/";
  }
  
  logout(){
	  let confirm = this.alertCtrl.create({
		  title: 'LOGOUT',
		  message: 'Are you sure you want to logout?',
		  buttons: [
			{
			  text: 'No',
			  handler: () => {
							
			  }
			},
			{
			  text: 'Yes',
			  handler: () => {
				this.logActivity(this.loggedInUser.uuid,"logout","na");
				this.storage.remove('chatbotmita-user');
				this.gotoHomePage();
			  }
			}
		  ]
		});
		confirm.present();
  }
  
  ionViewDidLoad() {
		console.log('ionViewDidLoad ChatPage');
		var THAT=this;
		$(document).off('click', '.user-click');
		$(document).on('click', '.user-click',function(ev){
			
			var data=$(this).attr("abp:data");
			var dataId=$(this).attr("abp:dataid");
			if(!dataId){
				dataId="0";
			}
			if(data!="searchbot"){
				$(this).parents(".lexResponseCard:first").remove();
				THAT.showRequest($(this).attr("abp:text"));
			}
			if(data!="exit" && data!="feedback" && data!="searchbot"){
				THAT.msgStack.push("<b>"+THAT.loggedInUser.firstname+"</b>: "+$(this).attr("abp:text"));
				if(data=="go-back"){
					THAT.threadStack.pop();
					var intentID= THAT.threadStack[THAT.threadStack.length-1];
					var msg="hi";
					if(THAT.intentList[intentID]){
						msg=THAT.intentList[intentID].text;
					}
					THAT.submitChat(msg,intentID,false);
				}
				else if(data.toLowerCase().indexOf("call")>=0){
					THAT.showHelpEmailText();
					THAT.logActivity(THAT.loggedInUser.uuid,"intent",data);
				}
				else if(data.toLowerCase()=="mailyes"){
					//THAT.sendEmail();
					//THAT.showFinalText();
					THAT.showTicketText();
					THAT.logActivity(THAT.loggedInUser.uuid,"intent",data);
				}
				else if(data.toLowerCase()=="mailno"){
					//THAT.showResponseText("Please call helpdesk.");
					THAT.showFinalText();
					//THAT.showITFeedbackText();
					THAT.logActivity(THAT.loggedInUser.uuid,"intent",data);
				}
				else if(data.toLowerCase()=="thanks"){
					THAT.showResponseText("Thank You for connecting with us.");
					//$(".choose-box").html("Thanks");
					THAT.showFinalText();
					//THAT.showITFeedbackText();
					THAT.logActivity(THAT.loggedInUser.uuid,"intent","was helpful");
				}
				else if(data.toLowerCase()=="rateyes"){
					THAT.showRatingText();
				}
				else if(data.toLowerCase()=="rateno"){
					THAT.showFinalText();
				}
				else{
					THAT.submitChat(data,dataId.toString(),false);
				}
			}else if(data=="feedback"){
				THAT.showITFeedbackText();
			}else if(data=="searchbot"){
				THAT.showSearchBot();
			}else{
				THAT.showResponseText("Thank You for connecting with us.");
				THAT.showResponseText("We hope to have the pleasure of serving you in future.");
				THAT.showResponseText("Have a nice day.");
				$(".choose-box").html("Thanks");
				THAT.storage.remove('chatbotmita-user');
				setTimeout(()=>{
					//THAT.gotoHomePage();
				},5000);
			}
			
		});
		
		$(document).off('click', '.show-more');
		$(document).on('click', '.show-more',function(ev){
			$(this).parents(".lexResponseCard:first").find('.card-item').show();
			$(this).remove();
		});
		
		$(document).off('click', '.show-more-content');
		$(document).on('click', '.show-more-content',function(ev){
			$(this).parents(".lexResponse:first").find('.content').removeClass("max-content");
			$(this).remove();
		});
		
		$(document).off('click', '.submit-rating');
		$(document).on('click', '.submit-rating',function(ev){
			THAT.saveRating($(this));
		});
		
		$(document).off('click', '.submit-comment');
		$(document).on('click', '.submit-comment',function(ev){
			THAT.comment=$("#bot-comment").val();
			THAT.saveComment($(this));
		});
		
		$(document).off('click', '.cancel-comment');
		$(document).on('click', '.cancel-comment',function(ev){
			THAT.comment="No";
			THAT.saveComment($(this));
		});
		
		$(document).off('click', '.submit-ticket');
		$(document).on('click', '.submit-ticket',function(ev){
			THAT.ticketcomment=$("#ticket-comment").val();
			if($("#ticket-comment").val()){
				THAT.saveTicket($(this));
			}
		});
		
		$(document).off('click', '.cancel-ticket');
		$(document).on('click', '.cancel-ticket',function(ev){
			$(this).parents(".lexResponseCard:first").remove();
			THAT.showRequest("No");
			THAT.ticketcomment="";
			THAT.showFinalText();
		});
		
		//$(document).off('click', '.rating-bar > span.active');
		$(document).on('click', '.rating-bar > span.active',function(ev){
			var value=$(this).attr("abp:value");
			THAT.rating=value;
			$(this).parent().find("span").removeClass("checked").each(function(index){
				if(index<value){
					$(this).addClass("checked");
				}
			});
		});
		
		$(document).ready(function () {
			var accessToken="";
			$('#loader').hide();
			$("#submit-chat").click(function(e){
				e.preventDefault();
				getSearchData();
			  
			});
			
			$("#chatbot-close").click(function(e){
				e.preventDefault();
				THAT.hideChatBot();
			});
			
			
			$("#search-chat-close").click(function(e){
				e.preventDefault();
				THAT.showSearchBotPanel=false;
			});
			
			$("#chat-msg-form").submit(function (e) {
				e.preventDefault();
				getSearchData();
			});
			
			$(document).off('click', '.dcm-list');
			$(document).on('click', '.dcm-list',function(e){
				e.preventDefault();
				var link=$(this).attr("href");
				//console.log(THAT.allparamObj);
				var itemId=link.replace("https://aaroananda.com/social/article/","");
				var item={
					"channel":"aaroananda",
					"id":itemId,
					"url":link
				};
				if(THAT.allparamObj["utm_source"]=="webapp"){
					$.ajax({
						"url": "https://shadow.aaroananda.com/litesnippet/articleId/"+itemId,
						"method": "GET",
						"timeout": 0,
						success: function (response) {
						  console.log("response", response);
						  item["url"]=response.web_url;
						  window.parent.postMessage(JSON.stringify(item), '*');
						},
						error: function (xhr, status, error) {
						  
						}
					  });
				}else{
					window.parent.postMessage(JSON.stringify(item), '*');
				}
				THAT.logActivity(THAT.loggedInUser.uuid,"bot-click",itemId);
			});
			
			
			$(document).off('click', '.q-chip');
			$(document).on('click', '.q-chip',function(ev){
				$("#chat-text").val($(this).text());
				getSearchData();
			});
			
			function getSearchData(){
				var stext=$("#chat-text").val();
				THAT.logActivity(THAT.loggedInUser.uuid,"bot-search",stext);
			  //var pl={"query":stext,"pageSize":10,"queryExpansionSpec":{"condition":"AUTO"},"spellCorrectionSpec":{"mode":"AUTO"}};
			  var pl={
					"query": stext,
					"pageSize": 10,
					"orderBy":"article_id desc",
					"queryExpansionSpec": {
						"condition": "AUTO"
					},
					"spellCorrectionSpec": {
						"mode": "AUTO"
					},
					"session": "projects/907681821053/locations/us/collections/default_collection/engines/aa-shadow-search_1731562286660/sessions/-"
				};
			  var strMsg='<div class="direct-chat-msg">';
			  strMsg+='<img class="direct-chat-img" src="https://img.icons8.com/color/36/000000/administrator-male.png" alt="message user image">';
			  strMsg+='<div class="direct-chat-text bengali-font">';
			  strMsg+=stext;	
			  strMsg+='</div>';
			  strMsg+='</div>';
			  $("#chat-messages-container").append(strMsg);
			  $('#loader').show();
			  $('#chat-msg-form').hide();
			  $.ajax({
					"url": "https://us-discoveryengine.googleapis.com/v1alpha/projects/907681821053/locations/us/collections/default_collection/engines/aa-shadow-search_1731562286660/servingConfigs/default_search:search",
					"method": "POST",
					"timeout": 0,
					"headers": {
					  "Authorization": "Bearer "+accessToken
					},
					"processData": false,
					"mimeType": "multipart/form-data",
					"contentType": "application/json",
					"data":JSON.stringify(pl),
					success: function (response) {
					 $('#loader').hide();
					 $('#chat-msg-form').show();
					 $("#chat-text").val("");
					 $("#chat-text").focus();
					  var obj=JSON.parse(response);
					  //console.log("response", obj);
					  if (obj.totalSize >0) {
						var aiDivId="ai-section"+Date.now();
						//$("#chat-messages-container").append('<div id="'+aiDivId+'" class="card pb-4"><span class="loader"></span></div>');
						
						var arrDataTemp=obj.results;
					
						var arrData=arrDataTemp.filter((tag, index, array) => array.findIndex(t => t.document.structData.article_id == tag.document.structData.article_id) == index);
						$("#chat-messages-container").append('<div class="card p-2"><strong>Search results</strong></div>');
						arrData.forEach((item) => {
							//console.log(item);
							var objData=item.document.structData;
							
							let jsValue = '<a href="'+objData.url+'" target="_blank" class="card dcm-list">';
							 jsValue+='<div class="card-body">';
							 jsValue+='	<div class="img">';
							 jsValue+='	  <img';
							 jsValue+='		src="https://rest.aaroananda.com/cdn-cgi/image/width=320,quality=70/'+objData.thumbnail+'"';
							 jsValue+='		alt="" srcset="">';
							jsValue+='	</div>';
							jsValue+='	<div class="info">';
							jsValue+='	  <h4 class="list-heading bengali-font">'+objData.title+'</h4>';
							jsValue+='	  <p class="bengali-font">'+objData.summary+'</p>';
							jsValue+='	</div>';
							jsValue+='  </div>';
							jsValue+='</a>';
							
							$("#chat-messages-container").append(jsValue);
							var conversationDiv = document.getElementById('chat-messages-container');			
							$("#chat-messages-container").animate({ scrollTop: $("#chat-messages-container")[0].scrollHeight }, 100);
							
						});
					  }
					  //getAIChats(obj.sessionInfo,stext,aiDivId);
					},
					error: function (xhr, status, error) {
					  $('#loader').hide();
					  $('#chat-msg-form').show();
					  //var err = eval("(" + xhr.responseText + ")");
					}
				  });
			}
			
			function getAIChats(session,text,divId){
			  $('#loader').show();
			  $('#chat-msg-form').hide();
			  var pl={
				"query": {
					"text": text,
					"queryId": session.queryId
				},
				"session": session.name,
				"relatedQuestionsSpec": {
					"enable": true
				},
				"answerGenerationSpec": {
					"ignoreAdversarialQuery": true,
					"ignoreNonAnswerSeekingQuery": true,
					"ignoreLowRelevantContent": true,
					"includeCitations": true,
					"modelSpec": {
						"modelVersion": "gemini-1.0-pro-002/answer_gen/v1"
					}
				}
				};
			  $.ajax({
					"url": "https://us-discoveryengine.googleapis.com/v1alpha/projects/907681821053/locations/us/collections/default_collection/engines/aa-shadow-search_1731562286660/servingConfigs/default_search:answer",
					"method": "POST",
					"timeout": 0,
					"headers": {
					  "Authorization": "Bearer "+accessToken
					},
					"processData": false,
					"mimeType": "multipart/form-data",
					"contentType": "application/json",
					"data":JSON.stringify(pl),
					success: function (response) {
					 $('#loader').hide();
					 $('#chat-msg-form').show();
					 $("#chat-text").val("");
					 $("#chat-text").focus();
					  var obj=JSON.parse(response);
					  //console.log("response", obj);
					  var jsValue="<div class='card-body'>";
					  var arrText=obj.answer.answerText.split("\n\n");
					  console.log("response", arrText);
					  for(var i=0;i<arrText.length;i++){
						if(i==0){
							jsValue+="<h5>"+arrText[i].replaceAll("## ","")+"</h5>";
						}else{
							var strT=arrText[i].replace("**", "<strong>").replace("**", "</strong>");
							strT=strT.replaceAll("*","");
							jsValue+="<p>"+strT+"</p>";
						}
					  }
					  jsValue+="</div>";
					  $("#"+divId).html(jsValue);
					  
					  var arrRelQ=obj.answer.relatedQuestions;
					  arrRelQ.forEach((item) => {
						 var strMsg='<div class="direct-chat-text bengali-font q-chip">';
						  strMsg+=item;	
						  strMsg+='</div>';
						  $("#"+divId).append(strMsg);
					  });
					  
					  var conversationDiv = document.getElementById('chat-messages-container');						
					  //$("#chat-messages-container").animate({ scrollTop: $("#chat-messages-container")[0].scrollHeight }, 100);
					  //$("#chat-messages-container").animate({ scrollTop: $("#"+divId).offset().top - $("#chat-messages-container").offset().top }, 100);
					  document.getElementById(divId).scrollIntoView();
					},
					error: function (xhr, status, error) {
					  $('#loader').hide();
					  $('#chat-msg-form').show();
					}
				  });
			
			}
			
			function getToken(){
			  
			  $.ajax({
					"url": "https://gauth.aaroananda.com/api/get-access-token",
					"method": "GET",
					"timeout": 0,
					success: function (response) {
					  console.log("response", response);
					  accessToken=response.accessToken;
					  $("#chat-text").val("কলকাতা");
					  getSearchData();
					},
					error: function (xhr, status, error) {
					  
					}
				  });
			
			}
			
			getToken();

		});
		
		this.webServices.getUserProfile(this.usertoken).subscribe(data => {
			console.log(data);
			this.loggedInUser["email"]=data.data.email;
			this.loggedInUser["firstname"]=data.data.name;
			this.loggedInUser["uuid"]=data.data.uuid_;
			
			this.logActivity(this.loggedInUser.uuid,"login","na");
			this.initialize();
			/*this.webServices.getMessage().subscribe(data => {
			  this.customMsg=data[0].message;
			  this.initialize();
			},
			err => 
			{ 
				this.initialize();
			});*/
		},
		err => 
		{ 
			//this.initialize();
			this.showError('Please login/register to use the Aaro Ananda Chatbot');
		});
  }
  
  openAnandaplex(){
		var item={
			"channel":"aaroananda",
			"page_link":"/social/ananda-plex"
		};
		if(this.allparamObj["utm_source"]=="webapp"){	
			item["id"]=1;
			item["url"]="https://www.aaroananda.com/ananda-plex";
		}
		window.parent.postMessage(JSON.stringify(item), '*');
  }
  
  openPujabrashiki(){
		var item={
			"channel":"aaroananda",
			"page_link":"/social/pujabarshiki"
		};
		if(this.allparamObj["utm_source"]=="webapp"){
			item["id"]=1;
			item["url"]="https://www.aaroananda.com/pujabarshiki";
		}
		window.parent.postMessage(JSON.stringify(item), '*');
  }
  
  openMagazine(){
		var item={
			"channel":"aaroananda",
			"page_link":"/social/magz-issue/10962285"
		};
		if(this.allparamObj["utm_source"]=="webapp"){
			item["id"]=1;
			item["url"]="https://www.aaroananda.com/magz-issue/anandamela/10962285";
		}
		window.parent.postMessage(JSON.stringify(item), '*');
  }
  
  
  openNewsAudio(){
		var item={
			"channel":"aaroananda",
			"page_link":"/social/khobor-sunun-list"
		};
		if(this.allparamObj["utm_source"]=="webapp"){
			item["id"]=1;
			item["url"]="https://www.aaroananda.com/khobor-sunun-list";
		}
		console.log(item);
		window.parent.postMessage(JSON.stringify(item), '*');
  }
  
  sendMessage(){
	this.submitChat(this.message,0,true);
  }
  
  eventHandler(ev){
	  if(ev.keyCode==13){
		 this.submitChat(this.message,0,true); 
	  }
  }
  
  submitChat(msg,intentId,showRequestFlag){
	  if(!msg){
		  return;
	  }
	  if(msg.toLowerCase()=="hi"){
		  this.threadStack=[];
		  this.msgStack=[];
		  this.rating=0;
		  this.comment="";
		  this.ratingId=0;
	  }
	  if($.inArray( intentId, this.threadStack)<0){
		this.threadStack.push(intentId);
	  }
	  console.log(this.threadStack);
	  
	  this.logActivity(this.loggedInUser.uuid,"intent",msg);
	  this.message="";
	  if(showRequestFlag){
		this.showRequest(msg);
	  }
	  this.showLoader();
	  $(".choose-box").html("Please wait...");
	  
	  this.webServices.getIntentByParent(intentId,this.lexUserId).subscribe(data => {
		  
		  console.log(data);
		  if(data.length>0){
			  $("#chat-loading").remove();
			  this.showResponse(data,true);
		  }else{
			  this.webServices.getIntentById(intentId,this.lexUserId).subscribe(datamore => {
				  console.log(datamore);
				  $("#chat-loading").remove();
				  this.showResponse(datamore,false);
				},
				err => 
				{ 
					$("#chat-loading").remove();
					console.log(err);
				});
		  }
		  
		},
		err => 
		{ 
			$("#chat-loading").remove();
			console.log(err);
			this.showError('Error: ' + err.message + ' (see console for details)');
		});

  }
	
	showLoader(){
		var conversationDiv = document.getElementById('conversation');
		var strHtml='<div id="chat-loading" class="bubble lexResponse">';
		strHtml+= '<div class="circleWrapper">';
		strHtml+= '  <div class="circle" id="circle1"></div>';
		strHtml+= '  <div class="circle" id="circle2"></div>';
		strHtml+= '  <div class="circle" id="circle3"></div>';
		strHtml+= '</div>';
		strHtml+= '</div>';
		$(conversationDiv).append(strHtml);
		this.content.scrollToBottom();
	}

	showSearchBot(){
		this.showSearchBotPanel=true;
		this.content.resize();
	}
	
	showChatBot(){
		this.showChatBotPanel=true;
		this.content.resize();
	}
	
	hideChatBot(){
		this.showChatBotPanel=false;
		this.content.resize();
	}
	
	showITFeedbackText(){
		this.showResponseText("Would you like to share your feedback about Aaro Ananda?");
		var conversationDiv = document.getElementById('conversation');
		var strHtml="<div class='lexResponseCard'>";
		strHtml+= "<div>Choose from below...</div>";
		strHtml+="<button class='user-click' abp:data='rateyes' abp:text='Yes'>Yes</button>";
		strHtml+="<button class='user-click' abp:data='rateno' abp:text='No'>No</button>";
		strHtml+="</div>";
		$(".choose-box").html("Choose from the list...");
		$(conversationDiv).append(strHtml);
		this.content.scrollToBottom();
	}
	
	showRatingText(){
		this.showResponseText("How do you feel about Aaro Ananda?");
		var conversationDiv = document.getElementById('conversation');
		var strHtml="<div class='lexResponseCard'>";
		
		strHtml+="<div class='rating-bar'>";
		for(var i=0;i<this.arrEmoji.length;i++){
			strHtml+="<span class='active' abp:value='"+(i+1)+"'>"+this.arrEmoji[i]+"</span>";
		}
		strHtml+="</div>";
		strHtml+="<button class='submit-rating'>Submit</button>";
		strHtml+="</div>";
		$(".choose-box").html("Please rate us...");
		$(conversationDiv).append(strHtml);
		this.content.scrollToBottom();
	}
	
	showRating(){
		var conversationDiv = document.getElementById('conversation');
		var strHtml="<div class='lexResponseCard'>";
		strHtml+="<div class='rating-bar'>";
		for(var i=0;i<this.rating;i++){
			strHtml+="<span abp:value='"+(i+1)+"'>"+this.arrEmoji[i]+"</span>";
		}
		strHtml+="</div>";
		strHtml+="</div>";
		$(conversationDiv).append(strHtml);
		this.content.scrollToBottom();
	}
	
	showCommentText(){
		this.showResponseText("Thanks for your feedback");
		this.showResponseText("Do you want to add any comments?");
		var conversationDiv = document.getElementById('conversation');
		var strHtml="<div class='lexResponseCard'>";
		strHtml+= "<div><textarea id='bot-comment'></textarea></div>";
		strHtml+="<button class='cancel-comment'>Skip</button>&nbsp;&nbsp;<button class='submit-comment'>Submit</button>";
		strHtml+="</div>";
		$(".choose-box").html("Please rate us...");
		$(conversationDiv).append(strHtml);
		this.content.scrollToBottom();
	}
	
	
	showTicketText(){
		this.showResponseText("Please add the details below");
		var conversationDiv = document.getElementById('conversation');
		var strHtml="<div class='lexResponseCard'>";
		strHtml+= "<div><textarea id='ticket-comment'></textarea></div>";
		strHtml+="<button class='cancel-ticket'>Skip</button>&nbsp;&nbsp;<button class='submit-ticket'>Submit</button>";
		strHtml+="</div>";
		$(".choose-box").html("Please write...");
		$(conversationDiv).append(strHtml);
		this.content.scrollToBottom();
	}
	
	showFinalText(){
		this.showResponseText("Do you need any further help?");
		var conversationDiv = document.getElementById('conversation');
		var strHtml="<div class='lexResponseCard'>";
		strHtml+= "<div>Choose from below...</div>";
		strHtml+="<button class='user-click' abp:data='hi' abp:text='Yes'>Yes</button>";
		strHtml+="<button class='user-click' abp:data='exit' abp:text='Exit'>No</button>";
		strHtml+="</div>";
		$(".choose-box").html("Choose from the list...");
		$(conversationDiv).append(strHtml);
		this.content.scrollToBottom();
	}
	
	showHelpDeskText(){
		this.showResponseText("Does it solve your problem?");
		var conversationDiv = document.getElementById('conversation');
		var strHtml="<div class='lexResponseCard'>";
		strHtml+= "<div>Choose from below...</div>";
		strHtml+="<button class='user-click' abp:data='thanks' abp:text='Yes'>Yes</button>";
		strHtml+="<button class='user-click' abp:data='call' abp:text='No'>No</button>";
		strHtml+="</div>";
		$(".choose-box").html("Choose from the list...");
		$(conversationDiv).append(strHtml);
		this.content.scrollToBottom();
	}
	
	showHelpEmailText(){
		this.showResponseText("Would you like to log a ticket?");
		var conversationDiv = document.getElementById('conversation');
		var strHtml="<div class='lexResponseCard'>";
		strHtml+= "<div>Choose from below...</div>";
		strHtml+="<button class='user-click' abp:data='mailyes' abp:text='Yes'>Yes</button>";
		strHtml+="<button class='user-click' abp:data='mailno' abp:text='No'>No</button>";
		strHtml+="</div>";
		$(".choose-box").html("Choose from the list...");
		$(conversationDiv).append(strHtml);
		this.content.scrollToBottom();
	}
	
	showResponseText(daText) {
		this.msgStack.push("Aaro Ananda – Assistant: "+daText);
		var conversationDiv = document.getElementById('conversation');
		var requestPara = document.createElement("P");
		requestPara.className = 'lexResponse';
		//requestPara.appendChild(document.createTextNode(daText));
		$(requestPara).html(daText);
		conversationDiv.appendChild(requestPara);
		this.content.scrollToBottom();
	}
  
	showRequest(daText) {
		var conversationDiv = document.getElementById('conversation');
		var requestPara = document.createElement("P");
		requestPara.className = 'userRequest';
		//requestPara.appendChild(document.createTextNode(daText));
		$(requestPara).html(daText);
		conversationDiv.appendChild(requestPara);
		this.content.scrollToBottom();
	}

	showError(daText) {
		var conversationDiv = document.getElementById('conversation');
		var errorPara = document.createElement("P");
		errorPara.className = 'lexError';
		errorPara.appendChild(document.createTextNode(daText));
		conversationDiv.appendChild(errorPara);
		this.content.scrollToBottom();
	}

	showResponse(lexResponse,hasMoreData) {

		var conversationDiv = document.getElementById('conversation');
		if (!hasMoreData) {
			var msgText=lexResponse[0].text;
			this.msgStack.push("Aaro Ananda – Assistant: "+msgText);
			var responsePara = document.createElement("P");
			responsePara.className = 'lexResponse';
			responsePara.appendChild(document.createTextNode(msgText));
			
			var str = msgText;
			var regex = /(https?:\/\/([-\w\.]+)+(:\d+)?(\/([\w\/_\.]*(\?\S+)?)?)?)/ig
			var replaced_text = str.replace(regex, "<a href='$1' target='_blank'>$1</a>");
			$(responsePara).html("<div class='content'>"+replaced_text+"</div>");
			conversationDiv.appendChild(responsePara);
			/*if($(responsePara).find(".content").get(0).scrollHeight > $(responsePara).find(".content").height()){
				$(responsePara).append("<div class='more-less-btns'><button class='show-more-content'>Show More...</button></div>");
			}*/
			
		}
		if(hasMoreData){
			var parentId=lexResponse[0].parent;
			var msgText:any="You can now get the support for your queries and give your feedback regarding the Aaro Ananda service from here.";
			if(parentId){
				msgText=this.intentList[parentId].text;
			}
			this.showResponseText(msgText);
			/*var responsePara = document.createElement("P");
			responsePara.className = 'lexResponse';
			responsePara.appendChild(document.createTextNode(msgText));
			conversationDiv.appendChild(responsePara);*/
			
			var strHtml="";
			if (lexResponse.length>=0) {
				strHtml+="<div class='lexResponseCard'>";
				strHtml+= "<div>Choose from below...</div>";
				var iCount=0;
				for(var i=0;i<lexResponse.length;i++){
					this.intentList[lexResponse[i].id]=lexResponse[i];
					iCount++;
					strHtml+="<button id='"+lexResponse[i].id+"' class='user-click card-item' abp:dataid='"+lexResponse[i].id+"' abp:data='"+lexResponse[i].intent+"' abp:text='"+lexResponse[i].intent+"'>"+lexResponse[i].intent+"</button>";
				}
				if(iCount>10){
					strHtml+="<button class='show-more'>Show More...</button>";
				}
				if(this.threadStack.length>1){
					strHtml+="<button class='user-click' abp:data='go-back' abp:text='Go Back'>Go Back</button>";
				}else{
					//strHtml+="<button class='user-click aa-content' abp:data='searchbot' abp:text='Content Search'>Content Search</button>";
					strHtml+="<button class='user-click' abp:data='feedback' abp:text='Feedback'>Feedback</button>";
					strHtml+="<button class='user-click' abp:data='exit' abp:text='Exit'>Exit</button>";
				}
				strHtml+="</div>";
				$(".choose-box").html("Choose from the list...");
			}else{
				//$(".choose-box").html("Choose from the list...");
			}
			$(conversationDiv).append(strHtml);
			if(iCount>10){
				$(conversationDiv).find(".lexResponseCard:last").find('.card-item:gt(5)').hide();
			}
		}
		
		if(!hasMoreData){
			//$(".choose-box").html("Thanks");
			$(".choose-box").html("Choose from the list...");
			this.showHelpDeskText();
		}
		this.content.scrollToBottom();
		/*if(lexResponse.dialogState=="ElicitIntent"){
			this.submitChat("hi",0,false);
		}*/
	}
	
	saveRating(elem){
		this.showLoader();
		$(elem).attr("disabled",true);
		this.webServices.saveRating(this.loggedInUser.email, this.rating, this.loggedInUser.firstname).subscribe(data => {
		  console.log(data);
		  $("#chat-loading").remove();
		  if(data.status){
			this.ratingId=data.dataObject.id;
			$(elem).parents(".lexResponseCard:first").remove();
			//$(elem).remove();
			console.log(this.ratingId);
			this.showRating();
			this.showCommentText();
		  }else{
			  $(elem).removeAttr("disabled");
		  }
		},
		err => 
		{ 
			$("#chat-loading").remove();
			$(elem).removeAttr("disabled");
		});
	}
	
	saveComment(elem){
		this.showLoader();
		$(elem).parents(".lexResponseCard:first").find("button").attr("disabled",true);
		this.webServices.saveComment(this.ratingId,this.loggedInUser.email, this.rating, this.loggedInUser.firstname,this.comment).subscribe(data => {
		  console.log(data);
		  $("#chat-loading").remove();
		  if(data.status){
			$(elem).parents(".lexResponseCard:first").remove();
			//$("#bot-comment").remove();
			this.showRequest(this.comment);
			this.showFinalText();
		  }else{
			 $(elem).parents(".lexResponseCard:first").find("button").removeAttr("disabled");
		  }
		},
		err => 
		{ 
			$("#chat-loading").remove();
			$(elem).parents(".lexResponseCard:first").find("button").removeAttr("disabled");
		});
	}
	
	
	saveTicket(elem){
		this.showLoader();
		$(elem).parents(".lexResponseCard:first").find("button").attr("disabled",true);
		var ticketTopic="";
		if($.inArray( "2", this.threadStack)>=0){
			ticketTopic="Subscribed_but_was_unable_to_access";
		}
		if($.inArray( "3", this.threadStack)>=0){
			ticketTopic="Pujabarshiki_issue";
		}
		this.webServices.createSupportTicket(this.usertoken,ticketTopic,this.ticketcomment).subscribe(data => {
		  console.log(data);
		  $("#chat-loading").remove();
		  if(data.status){
			$(elem).parents(".lexResponseCard:first").remove();
			//$("#bot-comment").remove();
			this.showRequest(this.ticketcomment);
			try{
				var dataTemp=JSON.parse(data.data);
				this.showResponseText("Your ticket number : "+dataTemp.ticketNumber);
			}catch(e){}
			this.showFinalText();
		  }else{
			 $(elem).parents(".lexResponseCard:first").find("button").removeAttr("disabled");
		  }
		},
		err => 
		{ 
			$("#chat-loading").remove();
			$(elem).parents(".lexResponseCard:first").find("button").removeAttr("disabled");
		});
	}
	
	
	logActivity(email, activity, intent){
		this.webServices.logActivity(email, activity, intent).subscribe(data => {
		  
		},
		err => 
		{ 
		});
	}
	
	sendEmail(){
		//console.log(this.msgStack);
		let subject="Aaro Ananda : Query raised by "+this.loggedInUser.firstname;
		let msg="<p>Dear Support team,</p>";
		msg+="<p>"+this.loggedInUser.firstname+" has raised a query through me. Request you to please attend and update "+this.loggedInUser.firstname+".</p>";
		msg+="<p>Here is the conversation details-</p>";
		msg+="<p>-------------------------------------------</p>";
		for(var i=0;i<this.msgStack.length;i++){
			msg+="<p>"+this.msgStack[i]+"</p>";
		}
		msg+="<p>-------------------------------------------</p><p>Regards</p>";
		msg+="<p><b>Aaro Ananda – Assistant</b></p>";
		
		//console.log(msg);
		this.webServices.sendEmail("support@aaroananda.com",this.loggedInUser.email, subject, msg).subscribe(data => {
		  
		},
		err => 
		{ 
		});
	}
	
}



// WEBPACK FOOTER //
// ./src/pages/chat/chat.ts